import { all, fork } from 'redux-saga/effects';
import account from './account';
import organizations from './organizations';
import events from './events';
import users from './users';
import admins from './admins';
import staticData from './staticData';
import reports from './reports';
import categories from './categories';
import articles from './articles';

export default function* watchers() {
  yield all([
    account,
    organizations,
    events,
    users,
    admins,
    staticData,
    reports,
    categories,
    articles,
  ].map(fork));
}
